export const InfoGradient = () => {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="54" height="54" rx="27" fill="#784EFF" fill-opacity="0.05" />
      <rect
        x="4.575"
        y="4.575"
        width="44.85"
        height="44.85"
        rx="22.425"
        fill="#EEE9FF"
      />
      <rect
        x="4.575"
        y="4.575"
        width="44.85"
        height="44.85"
        rx="22.425"
        stroke="url(#paint0_linear_6540_1363)"
        stroke-width="1.15"
      />
      <g clip-path="url(#clip0_6540_1363)">
        <g clip-path="url(#clip1_6540_1363)">
          <path
            d="M27 35C25.4178 35 23.871 34.5308 22.5554 33.6518C21.2398 32.7727 20.2145 31.5233 19.609 30.0615C19.0035 28.5997 18.845 26.9911 19.1537 25.4393C19.4624 23.8874 20.2243 22.462 21.3431 21.3431C22.462 20.2243 23.8874 19.4624 25.4393 19.1537C26.9911 18.845 28.5997 19.0035 30.0615 19.609C31.5233 20.2145 32.7727 21.2398 33.6518 22.5554C34.5308 23.871 35 25.4177 35 27C34.9977 29.121 34.1541 31.1545 32.6543 32.6543C31.1545 34.1541 29.121 34.9977 27 35V35ZM27 20.3333C25.6815 20.3333 24.3925 20.7243 23.2962 21.4569C22.1999 22.1894 21.3454 23.2306 20.8408 24.4488C20.3362 25.6669 20.2042 27.0074 20.4614 28.3006C20.7187 29.5938 21.3536 30.7817 22.286 31.714C23.2183 32.6464 24.4062 33.2813 25.6994 33.5386C26.9926 33.7958 28.3331 33.6638 29.5512 33.1592C30.7694 32.6546 31.8106 31.8001 32.5431 30.7038C33.2757 29.6075 33.6667 28.3185 33.6667 27C33.6647 25.2325 32.9617 23.5379 31.7119 22.2881C30.4621 21.0383 28.7675 20.3353 27 20.3333V20.3333Z"
            fill="#784EFF"
          />
          <path
            d="M28.3332 31.6669H26.9998V27.0002H25.6665V25.6669H26.9998C27.3535 25.6669 27.6926 25.8073 27.9426 26.0574C28.1927 26.3074 28.3332 26.6466 28.3332 27.0002V31.6669Z"
            fill="#784EFF"
          />
          <path
            d="M27 24.3331C27.5523 24.3331 28 23.8854 28 23.3331C28 22.7808 27.5523 22.3331 27 22.3331C26.4477 22.3331 26 22.7808 26 23.3331C26 23.8854 26.4477 24.3331 27 24.3331Z"
            fill="#784EFF"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6540_1363"
          x1="27"
          y1="4"
          x2="27"
          y2="50"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BBA7FF" />
          <stop offset="1" stop-color="#BBA7FF" stop-opacity="0" />
        </linearGradient>
        <clipPath id="clip0_6540_1363">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(19 19)"
          />
        </clipPath>
        <clipPath id="clip1_6540_1363">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(19 19)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
